import React from 'react';

import {
  FlexRow,
  formatPercentage,
  HashLength,
  TableData,
  TableRow,
} from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';

import {
  DelegatorResult,
  getAccountInfoLogo,
  MapDataResponseValidators,
} from '@block-explorer/entities';
import { TableDataAccountInfo } from '../table-data-account-info/table-data-account-info';
import { TableDataCurrencyAmount } from '../table-data-currency-amount/table-data-currency-amount';
import UndelegateButton from '../undelegate-button/undelegate-button';
import DelegateButton from '../delegate-button/delegate-button';

interface DelegationListItemProps {
  data: DelegatorResult;
  csprCurrencyRate: number | undefined;
}

export const DelegationListItem = ({
  data,
  csprCurrencyRate,
}: DelegationListItemProps) => {
  const logo = getAccountInfoLogo(data.validator_account_info);
  const name = data.validator_account_info?.info?.owner?.name;
  const validator = MapDataResponseValidators(
    data.bidder ? { data: data.bidder } : null
  );

  return (
    <TableRow>
      <TableData fitContent>
        <TableDataAccountInfo
          validatorAccount
          hashLength={HashLength.SMALL}
          logo={logo}
          name={name}
          publicKey={data?.validator_public_key}
          loading={!data}
          csprName={data?.validator_cspr_name}
        />
      </TableData>
      <TableData align="right">
        {data && (
          <BodyText variation="darkGray" size={3}>
            {data.bidder?.fee != null
              ? `${formatPercentage(data.bidder.fee)}%`
              : 'N/A'}
          </BodyText>
        )}
      </TableData>
      <TableData align="right">
        {data && (
          <TableDataCurrencyAmount
            amount={data.stake}
            tokenCurrencyRate={csprCurrencyRate}
            loading={!data}
          />
        )}
      </TableData>
      <TableData align="right">
        {data && (
          <FlexRow itemsSpacing={8} justify="flex-end">
            <UndelegateButton
              height="24"
              width="100"
              validatorInfo={validator.data}
            />
            <DelegateButton
              height="24"
              width="100"
              validatorInfo={validator.data}
            />
          </FlexRow>
        )}
      </TableData>
    </TableRow>
  );
};

export default DelegationListItem;
